import React from 'react'
import { CircleSmall20Filled } from "@fluentui/react-icons";

const TypingIndicator: React.FC<{ styles: any }> = ({ styles }) => (
  <div className={[styles.messageRow, styles.assistantRow].join(" ")}>
    <div className={styles.assistantMessage}>
      <div className={styles.typingIndicator}>
        <div className={[styles.typingDot, styles.dot1].join(" ")}>
          <CircleSmall20Filled />
        </div>
        <div className={[styles.typingDot, styles.dot2].join(" ")}>
          <CircleSmall20Filled />
        </div>
        <div className={[styles.typingDot, styles.dot3].join(" ")}>
          <CircleSmall20Filled />
        </div>
      </div>
    </div>
  </div>
);


export default TypingIndicator;
